import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getBranchLabel, getBranchLabelsForTimer } from '@/redux/dialogs/helper';
import { selectDraftDialogNodes } from '@/redux/dialogs/selectors';

type Props = { nodeId: string };

/**
 * Chip listing the originating branches that flow into a timer node, walking up
 * timer chains. Mounted only on `is_reminder` nodes so non-reminder Node renders
 * don't subscribe to the full draft nodes list.
 */
export const TimerBranchLabel = ({ nodeId }: Props) => {
  const { t } = useTranslation();
  const allNodes = useSelector(selectDraftDialogNodes);

  const labels = useMemo(() => getBranchLabelsForTimer(nodeId, allNodes), [nodeId, allNodes]);

  if (labels.length === 0) {
    return null;
  }

  const summary = labels
    .map(({ conditionName, conditionIndex }) => getBranchLabel(conditionName, conditionIndex, t))
    .join(', ');

  return (
    <div className="px-3 pb-2 text-xs text-muted-foreground">
      {t('ai_agents.reminder.timer_node_branches', 'From {{0}}', { 0: summary })}
    </div>
  );
};
